import { AppServerAPI } from '@sdbn/common';
import { UmbrueckungDetails } from '../model/umbrueckung-details';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslationService } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';
import { ResponseStatus } from '@sdbn/common';
import { ResponseMessage } from '@sdbn/common';
import { TransportStationAssignment } from '../../../widgets/control/sac-client/model/sac-client.model';


@Component({
    selector: 'app-complete-umbrueckung-dialog',
    templateUrl: './complete-umbrueckung-dialog.component.html',
    styleUrls: ['./complete-umbrueckung-dialog.component.scss'],
    standalone: false
})
export class CompleteUmbrueckungDialogComponent implements OnInit {

  loading = false;

  responseMessages: ResponseMessage[];

  details: UmbrueckungDetails;

  constructor(
    private appServerAPI: AppServerAPI,
    public dialogRef: MatDialogRef<CompleteUmbrueckungDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translationService: TranslationService
  ) {
    this.details = data.details;
  }

  ngOnInit() {
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  public cancel() {
    this.loading = true;
    this.responseMessages = [];

    const assignment = new TransportStationAssignment();
    assignment.transport = { id: this.details.id };
    assignment.station = { id: this.details.currentStationId };

    this.appServerAPI.execute<ServiceResponse>('/client/control/umbrueckung/cancel', assignment).subscribe(
      response => {

        if (response.status !== ResponseStatus.SUCCESS) {
          this.responseMessages = response.responseMessages;
        } else {
          this.dialogRef.close();
        }
        this.loading = false;
      }, error => {
        console.log('Unexpected error' + error);
        this.loading = false;
      }
    );
  }

  public complete() {

    this.loading = true;

    this.responseMessages = [];

    const assignment = new TransportStationAssignment();
    assignment.transport = { id: this.details.id };
    assignment.station = { id: this.details.currentStationId };

    this.appServerAPI.execute<ServiceResponse>('/client/control/umbrueckung/complete', assignment).subscribe(
      response => {

        if (response.status !== ResponseStatus.SUCCESS) {
          this.responseMessages = response.responseMessages;
        } else {
          this.dialogRef.close();
        }
        this.loading = false;
      }, error => {
        console.log('Unexpected error' + error);
        this.loading = false;
      }
    );
  }
}

